import { useState, useEffect } from 'react';

// Add a simple responsive hook
export function useWindowWidth() {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return width;
}

// Parse a date string in DD/MM/YYYY or fallback to Date constructor
export function parseWikiDate(dateStr: string | null | undefined): Date | null {
  if (!dateStr) return null;
  if (typeof dateStr === 'string' && /^(\d{2})\/(\d{2})\/(\d{4})$/.test(dateStr)) {
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  }
  const dateObj = new Date(dateStr);
  return isNaN(dateObj.getTime()) ? null : dateObj;
}
